import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { logger } from '../../../common/utils/logger';

export const onConvoStartersFailed = (props: {
	analyticsAttributes: any;
	error: string;
}): AnalyticsEventPayload => {
	try {
		return {
			action: 'failed',
			actionSubject: 'aiConvoStarters',
			eventType: 'track',
			attributes: {
				...props.analyticsAttributes,
				error: props.error,
			},
		};
	} catch (error) {
		logger.error({ error, functionName: 'onConvoStartersFailed' });
		return {};
	}
};
